import "./Terms.css";

const FIFATerms = () => {
  return (
    <div className="tandc-page">
      <div className="tandc">
        {/*  Page Heading */}
        <h3 className="page-title" align="center">
          Terms and Conditionsfdfdfdfd
        </h3>
        {/* Heading */}
        <p align="center">Coca-Cola® FIFA World Cup 2026 Promotion</p>

        <div className="term-container">
          <div align="center">
            <table border="1" cellspacing="0" cellpadding="0" width="669">
              <tbody>
                <tr>
                  <td valign="top">
                    <p>
                      <strong>Clause</strong> <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Title</strong> <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Terms and Conditions</strong> <strong></strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>1</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>
                        Promotion Details, Concept and Participation
                      </strong>
                      <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Coca-Cola® FIFA World Cup™ 2026 promotion</strong>
                      (“<strong>Promotion</strong>”) is a consumer promotion
                      organised by Coca-Cola India Private Limited (“
                      <strong>CCIPL</strong>”), wherein individuals, upon
                      scanning the QR Code on the Promotion Products (as defined
                      hereinbelow) can participate in and get a chance to win
                      Prize(s) (as defined in Clause 7) in accordance with the
                      terms and conditions mentioned herein.
                    </p>
                    <p>
                      The Promotion shall be valid for the individuals residing
                      in India except for the state of Tamil Nadu
                      <strong>(“Promotion Territory”)</strong>
                      and shall be applicable on 740ml, 750ml, 1L, Coca-Cola®
                      PET packs<strong>(“Promotion Product(s)”).</strong>By
                      participating in this Promotion, the Eligible Persons as
                      per Clause 5 (each a “<strong>Participant</strong>”)
                      accepts and agrees to abide by these terms and conditions
                      of the Promotion (“ <strong>Promotion</strong>
                      <strong>Terms</strong>
                      ”). It is hereby clarified that the Participant may
                      participate in the Promotion multiple times, but he/she
                      shall be eligible to win the “Prize(s)” as per Clause 7
                      during the Promotion Period.
                    </p>
                    <p>
                      The Promotion is advertised and promoted,
                      <em>inter alia</em>, through media including digital
                      media, point of sale materials, public announcements,
                      website, and other available media.
                    </p>
                    <p>
                      The Promotion is subject to all applicable central, state,
                      and local laws and regulations.
                    </p>
                    <p>
                      These Promotion terms and conditions (“
                      <strong>Terms</strong>”) will be hosted at {" "}
                      <a href="https://www.coke2home.com/halftime-surprise/coke-fifa/tnc">
                        https://www.coke2home.com/halftime-surprise/coke-fifa/tnc
                      </a>{" "}
                      <strong></strong>(“<strong> Promotion Platform</strong>”).
                    </p>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>2</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>CCIPL and Partners</strong> <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      This Promotion is organised by CCIPL, having its corporate
                      office at 16th floor, One Horizon Center, Golf Course
                      Road, DFL Phase V, Sector 43, Gurgaon.
                    </p>
                    <p>
                      The operational part of the Promotion is managed by
                      PREMIER SALES PROMOTIONS PRIVATE LIMITED, also known as “
                      <strong>BigCity</strong>”, a company governed under the
                      Companies Act, 1956 having its registered office at Mitra
                      Towers, 4 <sup>th</sup> Floor, Kasturba Road, Bangalore
                      560 001 (hereinafter referred to as (hereinafter referred
                      to as “<strong>Agency</strong>”)
                    </p>
                    <p>
                      The logistics support of this Promotion is managed by
                      MERCURIUS TRAVEL PRIVATE LIMITED, a company governed under
                      the Companies Act, 1956 having its registered office at 3,
                      B302, Mangalya Building, Marol Maroshi Road, Andheri
                    </p>
                    <p>
                      East, Mumbai, Mumbai Suburban, Maharashtra,
                      400059(hereinafter referred to as(hereinafter referred to
                      as
                      <strong>“Logistics Partner ”)</strong>
                    </p>
                    <p>
                      CCIPL, the Agency and the Logistic Partner may,
                      hereinafter be collectively referred to as “
                      <strong>Organiser</strong>”, as and where applicable.
                    </p>
                    <p>
                      The Organiser shall not be liable for any acts or
                      omissions of thirdparty service providers, including
                      airlines, hotels, or government authorities.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>3</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Deemed acceptance of terms and conditions</strong>
                      <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      Entry and participation in this Promotion will be deemed
                      as an unconditional and an unequivocal acceptance of these
                      Terms, including any modifications, revisions, and
                      amendments thereto. The decisions of CCIPL shall be final
                      and binding on the Participants in all matters related to
                      the Promotion. Further, the Participants recognize that
                      these Terms may be modified by CCIPL from time to time
                      without any prior/public notice by posting the applicable
                      terms and conditions on the Promotion Website. CCIPL also
                      reserves the right to cancel or terminate the Promotion at
                      any stage without assigning any reasons whatsoever.
                      Successfully entering the Promotion and winning a Prize is
                      subject to all requirements set forth herein.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>4</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Promotion Period</strong> <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      This Promotion will commence at 00:00:00 hrs Indian
                      Standard Time (“<strong>IST</strong>”) on{" "}
                      <strong>21</strong>
                      <strong>
                        <sup>st</sup>
                      </strong>
                      <strong>{" "} March 2026</strong> (“<strong>Start Date</strong>
                      ”) and will continue until <strong>23</strong>
                      <strong>
                        <sup>rd</sup>
                      </strong>
                      <strong>{" "} May 2026</strong>{" "} 11:59:59 pm IST (“
                      <strong>End Date</strong>”)
                      <strong>(“Promotion Period”)</strong>. Any entries
                      received outside the Promotion Periods shall not be
                      eligible for the Prize(s) applicable for that phase and
                      shall not be carried forward to any other promotional
                      scheme ahead.
                    </p>
                    <p>
                      Stock of The Coca-Cola Company Products without the
                      Promotion offer will also be available across India.
                    </p>
                    <p>
                      Further, certain stock of The Coca-Cola Company Products
                      containing the Promotion offer may be available before the
                      Promotion Period or may continue to be available even
                      after the Promotion Period. However, prospective
                      Participants understand and agree that they will not be
                      permitted to participate in the Promotion before
                      commencement of the Promotion Period and after the expiry
                      of the Promotion Period and further, agree not to raise
                      any claim or complaint against CCIPL, its affiliates or
                      its agents in this respect.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>5</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Eligibility</strong> <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      Subject to the criteria of Promotion Territory, entry and
                      participation in this Promotion is open to individuals who
                      satisfy each of the following criteria (“
                      <strong>Eligible Persons</strong>”):
                    </p>
                    <ol type="1" start={1}>
                      <li>Must have attained 18 (eighteen) years of age.</li>
                      <li>
                        Possess a valid mobile phone number registered with an
                        active SIM Card.
                      </li>
                      <li>
                        bear a good moral character and have not been implicated
                        or named in any legal proceedings (either civil or
                        criminal).
                      </li>
                      <li>
                        are not management, employees, directors or contractors,
                        or the family of the management, employees, directors or
                        contractors of CCIPL, their related entities or other
                        agencies, firms or companies associated with or related
                        to the Promotion (including suppliers of Prizes).
                      </li>
                    </ol>
                    <p>
                      Please note that any entry received from states other than
                      the Promotion Territory shall be declared as null and void
                      and shall not be taken into consideration for determining
                      the Winners of the Prize.
                    </p>
                    <p>
                      For the sake of clarity, this Promotion is not open to
                      Non-Resident Indians (NRIs), Overseas Citizens of India
                      (OCIs) and Persons of Indian Origin (PIOs).
                    </p>
                    <p>
                      Eligible Persons participating or seeking to participate
                      in the Promotion shall individually be referred to as “
                      <strong>Participant</strong>” and collectively as “
                      <strong>Participants</strong>”.
                    </p>
                    <p>
                      If any Eligible Person has listed his/her phone numbers on
                      the National Do Not Call Registry (“
                      <strong>NDNC Registry</strong>”), he/she shall de-register
                      from the NDNC Registry prior to participating in the
                      Promotion, till the completion of the Promotion (including
                      availing of the Prize (if applicable) under the
                      Promotion). Such persons agree not to make any claim or
                      raise any complaint whatsoever against CCIPL in this
                      respect. Please note that persons intending to participate
                      in the Promotion who have not de-registered themselves
                      from the NDNC Registry shall also have no right to make
                      any claim or raise any complaints against CCIPL, if they
                      do or do not receive any call or SMS with respect to their
                      application, participation and all other matters
                      pertaining to the Promotion.
                    </p>
                    <p>
                      By participating in the Promotion, each Participant hereby
                      agrees to receive:
                    </p>
                    <ol type="i" start={1}>
                      <li>
                        details and information on this Promotion, on their
                        respective mobile phones, through SMS or voice calls,
                        WhatsApp, during the entire tenure of the Promotion.
                      </li>
                      <li>
                        updates and announcements concerning CCIPL’s products
                        and promotions, on their respective mobile phones
                        (through SMS or voice calls or WhatsApp) and Email Ids.
                      </li>
                    </ol>
                    <p>
                      <strong>(“Marketing Communication”)</strong>
                    </p>
                    <p>
                      The Participant may opt-out of receiving Marketing
                      Communication from CCIPL at any time by emailing or
                      calling, using the contact information listed below. In
                      such a request, the Participant must indicate that he/she
                      wishes to stop receiving Marketing Communication from
                      CCIPL.
                    </p>
                    <p>
                      Email: {" "}
                      <a href="mailto:indiahelpline@coca-cola.com">
                        indiahelpline@coca-cola.com
                      </a>
                    </p>
                    <p>Consumer Helpline: 1800-208-2653</p>
                    <p>Timings:</p>
                    <p>9:00am–9:00pm (Mon-Sat)</p>
                    <p>9:00am-6:00pm (Sun)</p>
                    <p>
                      The Participant hereby agrees that he/she has read and
                      understood the Privacy Policy mentioned on the Promotion
                      Website and provides his/her unconditional consent to
                      collection of his/her personal information namely Name,
                      Mobile Number, Email ID, Address and Location. Further,
                      the Participant hereby provides his/her consent for
                      storage and processing of his/her personal information
                      collected for the purposes of sending communication
                      including but not limited to Marketing Communication.
                    </p>
                    <p>
                      <strong>Personal Information:</strong> For the purposes of
                      this Promotion, “Personal Information” shall include,
                      without limitation, name, mobile number, address, date of
                      birth, nationality and such identification or
                      travelrelated details as may be required solely for
                      verification and fulfilment of the Prize, including
                      passport details, visa status information and Permanent
                      Account Number (PAN), where applicable.
                    </p>
                    <p>
                      <strong>Collection and Purpose:</strong>Without prejudice
                      to the clause on Marketing Communications,
                      <strong></strong>the Participant expressly agrees and
                      consents to the collection, storage, processing and use of
                      such Personal Information solely for the purposes of
                      administering the Promotion, validating entries, selecting
                      winners and coordinating fulfilment of the Prize.
                    </p>
                    <p>
                      <strong>Limited Sharing with Third Parties</strong>: The
                      Participant further expressly agrees and consents that
                      CCIPL may share such Personal Information with its
                      authorised thirdparty service providers, including the
                      Agency, the Logistics Partner and travel partners,
                      strictly on a needtoknow basis, <strong></strong>for the
                      purposes of coordinating flight bookings, hotel
                      accommodation, travelrelated support and services
                      ancillary to and in connection with the Prize.
                    </p>
                    <p>
                      <strong>No Visa or Passport Assistance</strong>: The
                      Participant expressly acknowledges and agrees that neither
                      CCIPL nor any of its thirdparty service providers,
                      including the Agency and the Logistics Partner, shall be
                      responsible for providing any assistance, facilitation or
                      support, monetary or otherwise, in relation to
                      procurement, renewal, correction or issuance of passport,
                      visa or any other immigration or travel documentation.{" "}
                      <br />
                      Obtaining and maintaining valid passport, visa and all
                      other travel and immigration documents shall be the sole
                      responsibility of the Winner.
                    </p>
                    <p>
                      <br />
                      The Organiser shall not be responsible or liable, in any
                      way, monetary or otherwise, for rejection, delay,
                      nonissuance, expiry or invalidity of any passport, visa or
                      other travel document, or for the Winner’s inability to
                      travel for any reason whatsoever. In such event, the
                      Winner shall forfeit the Prize without any claim,
                      compensation or substitution.
                    </p>
                    <p>
                      All Personal Information shall be handled in accordance
                      with applicable laws by the Organiser and shall not be
                      used for any purpose other than as expressly stated
                      herein.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>6</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Participating in the Promotion</strong>
                      <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      The Participant can participate subject to the following
                      terms:
                    </p>
                    <ol>
                      <li>Buy a Coca-Cola® Promotion Product</li>
                      <li>
                        Scan QR code on Promotion Product to visit Coca-Cola®
                        official WhatsApp Channel.
                      </li>
                      <li>
                        By registering on the WhatsApp Channel, the
                        Participant(s) consent to the Terms &amp; Conditions and
                        the handling of personal information as per the Privacy
                        Policy posted on the Coca-Cola® official WhatsApp
                        channel.
                      </li>
                      <li>
                        Enter the unique code printed behind the label of the
                        Promotion Product.
                      </li>
                      <li>
                        Upon entering the unique code, the Participant shall be
                        eligible to enter the computerized random draw for a
                        chance to win the Promotion Prize in accordance with
                        Clause 7.
                      </li>
                      <li>
                        If the Participant is declared a Winner of the Promotion
                        Prize, the Participant shall be notified on the WhatsApp
                        channel, along with details of the Prize and
                        instructions for redemption.
                      </li>
                      <li>
                        If the participant does not win the Promotion Prize, at
                        the sole discretion of CCIPL, they may be placed in the
                        waitlist pool and will receive a notification on the
                        WhatsApp channel, including information about the next
                        steps. Inclusion in the waitlist shall not create any
                        right, entitlement, or legitimate expectation to receive
                        the Promotion Prize.
                      </li>
                      <li>
                        <strong>WINNER JOURNEY &amp; CLAIM PROCESS</strong>
                      </li>
                    </ol>
                    <p>
                      <strong>Notification and Claim Form Submission</strong>
                    </p>
                    <ol>
                      <ol type="a" start={1}>
                        <li>
                          Upon being declared a Winner, the Participant shall
                          receive an intimation via SMS/WhatsApp/email.
                        </li>
                        <li>
                          The Winner shall be required to submit their PAN
                          details and complete the prescribed Claim Form within
                          fortyeight (48) hours of receipt of such
                          communication.
                        </li>
                        <li>
                          Failure to submit the Claim Form within the stipulated
                          time shall result in automatic forfeiture of the
                          Prize, without any further notice.
                        </li>
                      </ol>
                    </ol>
                    <p>
                      <strong>
                        Visa and Travel Documentation Verification
                      </strong>
                    </p>
                    <ol type="a" start={1}>
                      <li>
                        Upon successful submission of the Claim Form within the
                        prescribed timeline, the Logistics Partner will contact
                        the Winner via call and/or email to seek details
                        relating to the Winner’s passport and U.S. visa status.
                      </li>
                      <li>
                        The Winner shall provide complete and accurate
                        visarelated details within two (2) weeks of such
                        request.
                      </li>
                      <li>
                        Failure to furnish the required details within the
                        specified timeline shall result in forfeiture of the
                        Prize.
                      </li>
                      <li>
                        The Organiser shall not be responsible for rejection,
                        delay, or denial of any visa application and shall bear
                        no liability arising therefrom.
                      </li>
                      <li>
                        The Winner acknowledges and agrees that obtaining and
                        maintaining a valid passport, visa(s), travel permits,
                        and compliance with all immigration, customs, and travel
                        regulations shall be the sole responsibility of the
                        Winner.
                      </li>
                      <li>
                        The Winner shall indemnify, defend, and hold harmless
                        CCIPL, its affiliates, officers, employees, agents, and
                        authorised agencies from and against any and all claims,
                        losses, liabilities, costs, damages, penalties,
                        expenses, or proceedings arising out of or in connection
                        with:
                      </li>
                    </ol>
                    <ol type="i" start={1}>
                      <li>
                        incorrect, incomplete, false, or misleading Personal
                        Information provided by the Winner;
                      </li>
                      <li>
                        non‑compliance with immigration, visa, or travel laws of
                        India, the United States, or any transit country; or
                      </li>
                      <li>
                        non-compliance with any rules, regulations, and/or
                        guidelines of the airlines, venue, hotels, FIFA or any
                        other such location to which the Winner is travelling as
                        part of the Prize. any action or decision of any
                        governmental or immigration authority.
                      </li>
                    </ol>
                    <ol type="a" start={7}>
                      <li>
                        Where a Winner is in possession of a Valid passport and
                        a Valid U.S. visa, and the same has been successfully
                        verified by the Logistics Partner, the Logistics Partner
                        will proceed with the bookings in relation to this
                        Prize, and the same shall be communicated to the Winner
                        via SMS/WhatsApp/Call/Email.
                      </li>
                      <li>
                        Where a Winner is in possession of a Valid passport but
                        not a Valid U.S. visa, subject to compliance with these
                        terms and conditions, the Organiser may, at their
                        discretion, issue to such Winner, a invitation letter (“
                        <strong>Invitation Letter</strong>”), upon request. The
                        Winner may use such Invitation Letter to independently
                        apply for obtaining a valid U.S. visa. Wherein the
                        Winner fails to secure the U.S. visa within two (2)
                        weeks from the date of issue of Invitation Letter, the
                        Prize shall stand forfeited, without any liability on
                        the Organisers.
                      </li>
                      <li>
                        The Prize may be modified, postponed, or withdrawn due
                        to changes in law, government restrictions, visa
                        regulations or any such regulatory action outside the
                        control of the Organiser.
                      </li>
                      <li>
                        It is clarified that any circumstances arising from
                        geopolitical tensions, war or military operations, or
                        partial or total strikes, whether in the host country or
                        any transit country, may result in suspension of the
                        Promotion and/or nonrealisation of the Prize. In such
                        circumstances, the Organisers shall not be liable to
                        provide any compensation to the Winner in any manner
                        whatsoever.
                      </li>
                      <li>
                        If such an event occurs during the course of travel, the
                        Organiser shall, on a bestefforts basis, endeavour to
                        arrange for the immediate return of the travelling
                        Winners to Delhi. Any onward travel, rescheduling, or
                        arrangements from Delhi to the Winner’s home location
                        shall be the sole responsibility and cost of the Winner.
                      </li>
                    </ol>
                    <p>
                      <strong>WAITLIST MECHANISM</strong>
                    </p>
                    <p>
                      The Organiser, in their discretion, may allow for some
                      Participants to be waitlisted (“Waitlisted
                      Participant(s)”) on a weekly basis. Waitlist Participants
                      will also be chosen through computerised random selection.
                      It is clarified that:
                    </p>
                    <ol type="a" start={1}>
                      <li>
                        Selection as a Waitlisted Participant(s) does not
                        guarantee winning the Prize.
                      </li>
                      <li>
                        Placement on the waitlist only confers a contingent
                        opportunity to be upgraded to Winner status.
                      </li>
                    </ol>
                    <p>
                      <strong>WAITLISTED PARTICIPANT PROCESS</strong>
                      <strong></strong>
                    </p>
                    <p>
                      <strong>Claim Form Submission</strong>
                    </p>
                    <ol type="a" start={1}>
                      <li>
                        Upon being notified as a Waitlisted Participant, the
                        Participant will be required to submit their PAN details
                        and complete the Claim Form within fortyeight (48) hours
                        of receipt of such notification.
                      </li>
                      <li>
                        Failure to submit the Claim Form within the stipulated
                        time shall result in forfeiture of the waitlist
                        opportunity.
                      </li>
                    </ol>
                    <p>
                      <strong>Confirmation of Waitlist Status</strong>
                    </p>
                    <ol type="a" start={1}>
                      <li>
                        Upon successful submission of the Claim Form within the
                        prescribed timeline, the Waitlisted Participant shall be
                        informed about : (i) successful verification of the
                        Claim Form; and <br />
                        (ii) Confirmation of Prize and consequent travel.
                      </li>
                      <li>
                        In the event a Waitlisted Participant has a Valid
                        Passport and valid U.S. Visa, or has a valid passport
                        but not a valid U.S. Visa – the terms as under “
                        <strong>
                          Visa and Travel Documentation Verification”
                        </strong>
                        to the extent applicable, shall apply.
                      </li>
                    </ol>
                    <ol type="1" start={9}>
                      <li>
                        All timelines specified herein are of the essence, and
                        failure to adhere strictly shall result in automatic
                        forfeiture.
                      </li>
                      <li>
                        Prizes must be redeemed within the Promo period and
                        within the timeframe during each step
                        <strong>(“Redemption Window”)</strong>
                        using a claim form. Any Prize not claimed by the
                        Redemption Window will be forfeited.
                      </li>
                      <li>
                        Participants may participate any number of times to win
                        the Prize(s), however, it is clarified that each
                        Participant will be eligible to win up to a maximum of
                        <strong>one Prize</strong> per Mobile Number during the
                        Promotion Period.
                      </li>
                      <li>
                        Participants will also be notified via
                        SMS/Email/WhatsApp of the details of the Prize(s) won
                        &amp; instructions on how to redeem their Prize(s).
                      </li>
                      <li>
                        Any forfeiture exercised will be binding and final on
                        the participants.
                      </li>
                      <li>
                        Entry by proxy is not permitted. Participants can only
                        enter in their own name. The Participants shall be
                        solely responsible for any local calls / STD charges
                        applicable by their telecom service providers on the
                        Promotion entries.
                      </li>
                    </ol>
                    <p>
                      <strong>NOTE:</strong> All Winners will be required to
                      execute, via wet signatures, a Declaration cum Waiver
                      prior to commencement of travel as part of the Prize. Any
                      failure to execute said Declaration cum Waiver, shall be
                      treated as forfeiture of Prize on part of the Winner.
                    </p>
                    <p>
                      <strong>Google Gemini Experience</strong>: Participants
                      may get a chance to access and explore a unique experience
                      on Google Gemini platform, which include an AI‑enabled
                      interactive football‑themed game for engagement purposes
                      only. Participant acknowledges and understands that this
                      is only an experiential activity which, does not
                      constitute a game of chance or skill for reward, and does
                      not entitle the Participant to any prize, monetary
                      benefit, or additional consideration. CCIPL makes no
                      representations or warranties in relation to the
                      performance, availability, or functionality of such
                      third‑party platform.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>7</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Prizes and Winners</strong> <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      During the Promotion Period, Participants on the basis of
                      valid participation as per the Terms of Clause 6, shall
                      get a chance to win the following Prize(s):
                    </p>
                    <p style={{textDecoration:"underline"}}>
                      <strong>Promotion Prize/Prize (Once per Winner):</strong>
                    </p>
                    <ol>
                      <li>
                        Attend a live match of the FIFA World Cup 2026 to be
                        held in Dallas, Texas, United States of America on 25
                        <sup>th</sup> June 2026. The match date may be subject
                        to change based on, including but not limited to, the
                        FIFA World Cup 2026 match schedule and availability of
                        match tickets and the final details of travel will be
                        confirmed by the Logistic Partner.
                      </li>
                    </ol>
                    <ol type="a" start={1} style={{marginLeft:"0rem"}}>
                      <li>
                        The Prize shall consist of an all‑expenses paid trip for
                        the Winner, which includes:
                      </li>
                    </ol>
                    <ol type="i" start={1} style={{marginLeft:"1.9rem"}}>
                      <li>
                        Round‑trip economy class air travel from Delhi to
                        Dallas, USA;
                      </li>
                      <li>
                        Any transfers within USA to the extent of the Promotion.
                        Two (2) nights/three (3) days Hotel accommodation and
                        pre-set meals at the Hotel for the duration of stay in
                        Dallas, USA and
                      </li>
                      <li>
                        One (1) General Stand category match ticket for a FIFA
                        World Cup 2026 match.
                      </li>
                      <li>
                        Travel insurance for duration of travel, details of
                        which to be provided by the Logistic Partner along with
                        booking details. Additional Terms &amp; Conditions as
                        provided by the insurance company in relation to this
                        travel insurance shall be applicable. Travel insurance
                        plan is at the discretion of the Organiser.
                      </li>
                    </ol>
                    <ol type="a" start={2}>
                      <li>
                        The match schedule, travel itinerary, duration of stay,
                        airline, hotel, seat category, and all other
                        arrangements will be communicated by the Logistics
                        Partner to the Winner. No request for modification,
                        upgrade, substitution or extension of trip shall be
                        entertained.
                      </li>
                      <li>
                        Attendance at the match is subject to availability,
                        scheduling and applicable regulations, and CCIPL does
                        not guarantee the specific match, teams or seating
                        location.
                      </li>
                    </ol>
                    <p>
                      <strong>NOTE:</strong>
                    </p>
                    <ol type="1" start={1}>
                      <li>
                        The Winner shall be independently responsible for their
                        travel to and fro between their home location and Delhi
                        and related cost. The Organisers are not responsible for
                        providing any travel, or travel support, monetary or
                        otherwise, in relation to the same.
                      </li>
                      <li>
                        The Round-trip from Delhi to Dallas, USA, may or may not
                        be direct, connected and/or inclusive of layovers. Such
                        information will be communicated to the Winner, as part
                        of the bookings, by the Logistics Partner.
                      </li>
                    </ol>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>8</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Selecting and contacting Eligible Winners</strong>
                      <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <ol type="i" start={1}>
                      <li>
                        The Participants will be eligible to receive the Prize
                        subject to the Terms detailed herein.
                      </li>
                      <li>
                        Winners will be selected through a computerized random
                        selection from the pool of valid submissions/ entries,
                        in accordance with these Terms &amp; Conditions.
                      </li>
                      <li>
                        The Participants acknowledge not to raise any claim or
                        complaint against CCIPL due to technical failure or any
                        other causes beyond the control of CCIPL.
                      </li>
                      <li>
                        Prizes once awarded cannot be replaced under any
                        circumstances.
                      </li>
                      <li>
                        NOTE: The Winner must have a valid passport issued by
                        the Government of India, and a valid Visa issued by the
                        Government of the United States of America “
                        <strong>Valid Passport</strong>” shall mean a passport
                        issued by the Government of India, having at least one
                        (01) year of validity as on the date of participation by
                        the Participation. “<strong>Valid Visa</strong>” or “
                        <strong>Valid U.S. Visa</strong>” shall refer to a visa
                        issued by the State Department or its authorised Embassy
                        in India for entry and stay in the country of United
                        Stated of America.
                      </li>
                    </ol>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>9</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Conditions relating to the Prize</strong>
                      <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <ol type="i" start={1}>
                      <li>
                        CCIPL shall not be held responsible for any deficiency,
                        defect, inadequacy, or irregularity in the Prize(s).
                      </li>
                      <li>
                        The Winner(s) may not exchange or assign the Prizes and
                        shall not be entitled to any compensation whether in
                        cash or kind from CCIPL.
                      </li>
                      <li>
                        No portion of the Prizes offered under the Promotion is
                        redeemable for cash or kind from CCIPL. The Prizes are
                        also not refundable or transferable and cannot be
                        exchanged.
                      </li>
                      <li>
                        No Prize will be awarded if the information presented by
                        the Participant(s) at the time of entering the
                        Promotion, or at any subsequent stage is factually
                        incorrect.
                      </li>
                      <li>
                        In the event of death of the Winner, no claim from the
                        nominee or his/her legal heirs of the Winner shall be
                        entertained for receiving the Prize.
                      </li>
                      <li>
                        Prize shall be provided to the Winners on an "as-is
                        basis" and without any warranty or guarantee concerning
                        the quality, suitability or comfort, and CCIPL and/or
                        its associates, affiliates and/ or its management,
                        directors, officers, agents, representatives shall not
                        be responsible for or liable (including but not limited
                        to the product and service liabilities) for deficiency
                        and/ or defect of any product/service and/or the Prize
                        or for any kind of consequential damages/ loss, in any
                        manner whatsoever. The guarantee and warranty of the
                        Prizes shall be transferred to the Winners as received
                        from the Manufacturer / Distributor.
                      </li>
                      <li>
                        (vii)Participant has any grievance with respect to the
                        Prize, he/she may directly contact the manufacturer.
                      </li>
                      <li>
                        (viii)The image of the Prize depicted on the press
                        ads/posters/TVC's/pack shots etc. are for illustrative
                        purposes only and the actual Prize may vary from the
                        depiction made.
                      </li>
                      <li>
                        It is to be noted that in the event the Winner does not
                        take the Prize in the time and manner stipulated, then
                        the Prize shall be forfeited by the Winner and cash or
                        any monetary benefits in kind shall not be awarded in
                        lieu of the Prize. Prizes must be taken as offered and
                        cannot be varied.
                      </li>
                      <li>
                        <strong>Special Terms for the Prize</strong>
                        <strong></strong>
                      </li>
                    </ol>
                    <ol>
                      <ol type="a" start={1}>
                        <li>
                          It is hereby clarified that CCIPL, Agency or Logistics
                          Partner shall not be responsible for the Winner(s)
                          having and/or acquiring a valid passport, visa, or any
                          other such required documentation either from the
                          government of India or the government of the
                          destination country. The Winner(s) shall be
                          responsible for familiarizing themselves with the
                          required documentation for such travel. It is
                          abundantly clarified that CCIPL, Agency or Logistics
                          Partner shall not be held liable at any time for the
                          approval or rejection of an application for Passport
                          or VISA for the home or destination country for any
                          reason whatsoever. Such liability shall exclusively
                          lie with the Winner(s).
                        </li>
                        <li>All expenses paid trip shall be inclusive of:</li>
                        <ol type="i" start={1}>
                          <li>
                            To and fro journey from Delhi Airport to Dallas, USA
                          </li>
                          <li>
                            Two (2) nights/three (3) days Hotel accommodation
                            and pre-set meals at the Hotel for the duration of
                            stay in Dallas, USA and
                          </li>
                          <li>
                            Any transfers within USA to the extent of the
                            Promotion.
                          </li>
                          <li>
                            One (1) General Stand category match ticket for a
                            FIFA World Cup 2026 match.Travel insurance for
                            duration of travel, details of which to be provided
                            by the Logistic Partner along with booking details.
                            Additional Terms &amp; Conditions as provided by the
                            insurance company in relation to this travel
                            insurance shall be applicable. Travel insurance plan
                            is at the discretion of the Organiser.
                          </li>
                        </ol>
                        <li>
                          The Logistic Partner shall be the on-ground
                          coordinator for the duration of stay and travel
                        </li>
                        <li>
                          Any addition or deduction of experiences forming part
                          of the trip shall be at the discretion of CCIPL
                        </li>
                        <li>
                          An itinerary detailing travel schedules, internal
                          transfers, event attendance and return travel shall be
                          shared with the Winner upon commencement of the trip
                          (“<strong>Itinerary</strong>”), and the Winner shall
                          be solely responsible for strictly adhering to such
                          itinerary. In the event the Winner fails to adhere to
                          the itinerary or deviates from the scheduled timings,
                          resulting in missing any internal travel, flights,
                          buses, transfers, ground transportation or the
                          scheduled return flight to India, the Organiser shall
                          have no responsibility or liability whatsoever, and
                          any additional travel, accommodation or other
                          arrangements shall be made and borne solely by the
                          Winner. Any overstay beyond the duration specified in
                          the Itinerary, whether due to missed travel, delays or
                          personal reasons, shall be entirely at the Winner’s
                          cost and risk, and the Organiser shall not be
                          responsible for any expenses, compensation, penalties,
                          immigration issues, visa violations, legal
                          consequences or cost of return travel arising from
                          such overstay or noncompliance with applicable laws of
                          the host country.
                        </li>
                        <li>
                          Any experiences undertaken by any of the Winner(s)
                          during the stay, which does not form part of the
                          Prize, shall be solely at the cost, expense and
                          liability of the said Winner and the Organiser shall
                          not be liable for the same.
                        </li>
                        <li>
                          The Winner(s) shall be liable to comply with the
                          applicable law USA during the duration of stay. The
                          Organiser shall not be liable for any non-compliance
                          by the Winner(s). Deportation: In the event of any act
                          or omission on the part of the Winner in the USA which
                          results in the Winner's deportation or removal from
                          the USA by any governmental, immigration or law
                          enforcement authority, the Organiser shall bear no
                          liability whatsoever, whether monetary or otherwise,
                          in connection with or arising from such deportation.
                          It is expressly clarified that the Organiser shall not
                          be responsible for providing any assistance, support,
                          or arrangements, including but not limited to travel,
                          accommodation, transportation, or any financial
                          support, for the Winner's return journey to India or
                          to any other location. All costs, expenses, and
                          arrangements relating to the Winner's repatriation or
                          return travel following deportation shall be borne
                          solely and exclusively by the Winner. The winner shall
                          be liable to comply with any additional rules,
                          regulations, terms and conditions of the venue of play
                          and/or travel/lodging, and shall be liable directly
                          for any act or omission by the Winner. It is hereby
                          abundantly clarified that The Organiser shall
                          undertake no liability on behalf of the Winner with
                          respect to the same.
                        </li>
                        <li>
                          In the event any Winner(s) is not allowed port of
                          entry in the USA or leave India for any reason
                          whatsoever, specifically immigration laws, the
                          Logistics Partner will coordinate the return of said
                          winner to Delhi via commercial air travel, subject to
                          applicable law of the concerned territory. The
                          Winner(s) shall be responsible for ensuring medical
                          and mental fitness to travel internationally and
                          attend the event - and shall sufficiently disclose any
                          ailments preventing the Winner(s) from availing the
                          Prize at the earliest to the Agency. CCIPL shall not
                          be liable for any medical issues that the Winner may
                          face.
                        </li>
                        <li>
                          The Organiser will not be held responsible for any
                          alterations to the schedule, delays, or any other
                          changes that may lead to direct or indirect losses for
                          the Winner.
                        </li>
                      </ol>
                    </ol>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>10</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Publicity</strong> <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      The Participants undertake and irrevocably and
                      unconditionally permit CCIPL to cover the Promotion
                      through various media including newspapers, radio,
                      television including news and other channels, internet,
                      point of sale materials, etc., and shall not raise any
                      objection, protest, or demur whatsoever to such coverage
                      or in this regard. Further, the Participants also
                      understand and agree that their responses may be
                      publicised as part of this Promotion.
                    </p>
                    <p>
                      The Winners must, at the request of CCIPL, participate in
                      all promotional activity (such as publicity and
                      photography) surrounding the winning of the Prize, free of
                      charge, and they consent to CCIPL using their name and
                      image in all promotional materials.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>11</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Intellectual Property</strong> <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      All right, title, and interest, including but not limited
                      to the Intellectual Property Rights, in the promotional
                      material(s), and in any and all responses received, or
                      other materials created during or for the Promotion, as a
                      part of the Promotion or otherwise, shall vest solely and
                      exclusively with CCIPL at all times. CCIPL or any person
                      or entity permitted by CCIPL in this regard shall be
                      entitled to use any information in connection with the
                      entry in any media for future promotional, marketing,
                      publicity and any other purpose, without any permission
                      and or payment to the Participant. CCIPL may use the
                      material in any medium in any reasonable manner it sees
                      fit. Copyright in any such material remains the sole
                      property of CCIPL.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>12</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>General Conditions</strong> <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>General Terms and Conditions:</strong>
                    </p>
                    <ul>
                      <li>
                        Each Participant represents and warrants that he/she is
                        legally competent to enter into binding contracts under
                        applicable laws. By taking part and/or entering into the
                        Promotion the Participant warrants that all information
                        provided by Participant regarding Participant's name,
                        age, state, city, address, phone number, etc., is true,
                        correct, accurate and complete.
                      </li>
                      <li>
                        The decision of the Organiser, as regards the selection
                        of winners and distribution of the prizes shall be
                        final, subject only to CCIPL ‘s approval. No
                        correspondence or any other claims whatsoever, in this
                        regard will be entertained.
                      </li>
                      <li>
                        No queries, claims, dispute, complaints or grievances
                        shall be entertained by the Organiser after 30 days from
                        the date of the closure of the Promotion.
                      </li>
                      <li>
                        The prize cannot be exchanged and is not transferable
                        and cannot be converted into cash.
                      </li>
                      <li>
                        The Agency shall provide the prize on an "as-is basis"
                        and without any warranty or guarantee concerning the
                        quality, suitability or comfort, and CCIPL and/or its
                        associates, affiliates and/ or its management,
                        directors, officers, agents, representatives shall not
                        be responsible for or liable (including but not limited
                        to the product and service liabilities) for deficiency
                        and/ or defect of any product/service and/or the prize
                        or for any kind of consequential damages/ loss, in any
                        manner whatsoever.
                      </li>
                      <li>
                        CCIPL reserves the right to change, defer, alter or
                        cancel this Promotion in part or full, or change any or
                        all of the terms and conditions that are applicable,
                        without giving prior intimation/notice of any kind and
                        will not be liable for any consequential losses/damages.
                        Any decision of CCIPL in this regard and in general with
                        respect to this Promotion and the terms and conditions
                        thereto shall be final, binding and non-Offer able.
                      </li>
                      <li>
                        Nothing contained herein amounts to a commitment or
                        representation by CCIPL to conduct further Promotion.
                      </li>
                      <li>
                        CCIPL reserves the right to change any details of the
                        Promotion, including but not limited to amending these
                        terms and conditions, the type of Promotion, submission
                        mechanism, eligibility criteria, term of the Promotion,
                        and the prizes for the Promotion. CCIPL reserves the
                        right to amend, temporarily suspend or withdraw the
                        Promotion in its absolute discretion provided that CCIPL
                        shall not exercise this right unreasonably.
                      </li>
                      <li>
                        CCIPL shall not be liable to award/provide the prize(s)
                        and/or declare the winners of the prizes of the
                        Promotion due to any cause beyond its reasonable control
                        or foresight, including but not limited to, act of god,
                        insurrection or civil disorder, religious strife, war or
                        military operations, terrorist act, partial or total
                        strikes, either internal or external, lock-out,
                        epidemic, blockage of means of transport or of supplies,
                        national or local emergency, earthquake, fire, storm,
                        flood, water damage, governmental, regulatory or legal
                        restrictions, acts or omissions of persons for whom
                        CCIPL is not responsible.
                      </li>
                      <li>
                        The decision of CCIPL shall be final in all regards and
                        no communication shall be entertained in this regard.
                        None of the provisions of these Terms and Conditions
                        shall be deemed to constitute a partnership or agency
                        between any Participant and CCIPL and the Participant
                        shall not have the authority to bind CCIPL in any manner
                        whatsoever.
                      </li>
                      <li>
                        CCIPL or any of its respective
                        officers/employees/directors shall not be responsible
                        for delayed, lost, mutilated, corrupted or illegible
                        documents etc.
                      </li>
                      <li>
                        The Organiser shall not be liable to perform any of
                        its/their respective obligations under the Promotion or
                        in respect of the prize where it is unable to do so as a
                        result of circumstances beyond its/their control in the
                        nature of fire, explosions, natural calamities, state
                        emergency, riots, or any other Force Majeure condition,
                        etc., and shall not be liable to compensate the
                        Participant in these circumstances.
                      </li>
                      <li>
                        The Organiser shall not be accountable/liable for any
                        disruptions/stoppages/interruptions or cancellation of
                        the Promotion due to any government restrictions.
                      </li>
                      <li>
                        Failure to exercise or delay in exercising a right or
                        remedy provided hereunder or by law does not constitute
                        a waiver of the right or remedy or waiver of other
                        rights or remedies on the part of The Organiser.
                      </li>
                      <li>
                        The Organiser accepts no responsibility for late, lost,
                        incomplete, incorrectly submitted, delayed, illegible,
                        corrupted or misdirected entries, loss of SMS, loss of
                        internet connectivity, unique codes, documents, demand
                        drafts, claims or correspondence whether due to error,
                        omission, alteration, tampering, unauthorized data
                        hacking, deletion, theft, destruction, virus attack,
                        transmission interruption, communications failure,
                        hardware failure or otherwise. The Organiser shall not
                        be liable for any consequences of user error including
                        (without limitation) costs incurred.
                      </li>
                      <li>
                        If a Participant is dissatisfied with the Promotion or
                        the Promotion rules and/or any content or any
                        requirements of the Promotion form, the materials
                        available related thereto, or with these terms and
                        conditions, his/her sole and exclusive remedy is to not
                        participate in the Promotion.
                      </li>
                      <li>
                        If a person chooses to access the Promotion Website from
                        outside India, he/she shall do so on his/her own
                        initiative and shall be responsible for compliance with
                        applicable local laws of the country.
                      </li>
                      <li>
                        The operational part of the scheme like redemption of
                        prize &amp; dispatches shall be managed by the Agency;
                        However, promotional product will be distributed through
                        CCIPL Distributor/dealer.
                      </li>
                      <li>
                        The participation in the Promotion is purely voluntary
                        and the same shall be construed as an acceptance of the
                        terms and conditions stipulated herein.
                      </li>
                      <li>Release and Limitations of Liability:</li>
                    </ul>
                    <ol>
                      <ol type="i" start={1}>
                        <li>
                          CCIPL, the Agency and the Logistics Partnershall under
                          no circumstances be liable, whether jointly or
                          severally, for any loss or damage suffered or
                          sustained (including but not limited to consequential
                          loss), including for personal injury or property
                          damage suffered or sustained, as a result of
                          acceptance of any prize.
                        </li>
                        <li>
                          By entering the Promotion, the Participant hereby
                          releases from and agrees to indemnify CCIPL, and/ or
                          any of its respective officers/employees from and
                          against all liability, cost, loss or expense arising
                          out of acceptance of the prize or participation in the
                          Promotion including (but not limited to) personal
                          injury and damage to property and whether direct,
                          indirect, consequential, foreseeable, due to some
                          negligent act or omission, or otherwise.
                        </li>
                        <li>
                          The Organiser accept no liability, whether jointly or
                          severally, for any errors or omissions, whether on
                          behalf of itself, Agency or third parties in relation
                          to the prizes.
                        </li>
                        <li>
                          The Participant shall be solely responsible for any
                          consequences which may arise due to his/her
                          participation in the Promotion by conducting an
                          illegal act. Participant also undertakes to indemnify
                          CCIPL and/or the Agency and their respective officers,
                          directors, employees and agents on the happening of
                          such an event (including without limitation cost of
                          attorney, legal charges etc.) on full indemnity basis
                          for any loss/damage suffered by The Organiser on
                          account of such act on the part of the Participant.
                        </li>
                        <li>
                          In consideration of CCIPL allowing the Participant(s)
                          to take part in the Promotion , to the maximum extent
                          permitted by law, the Participant(s) waive and release
                          each and every right or claim, all actions, causes of
                          actions (present or future) each of them has or may
                          have against CCIPL , its respective agents, directors,
                          officers, business associates, group companies,
                          sponsors, employees, or representatives for all and
                          any injuries, accidents, or mishaps (whether known or
                          unknown) or (whether anticipated or unanticipated)
                          arising out of the Promotion or related to the
                          Promotion or the prize of the Promotion.
                        </li>
                        <li>
                          CCIPL reserve the right and discretion to disqualify
                          any participant from participating and further
                          reserves the right to rescind any Winner’s travel,
                          stay or event tickets- partially or fully in the event
                          of any negligence, misconduct, willful or otherwise,
                          including but not limited to, misbehavior,
                          falsification of any information, inappropriate
                          behavior with Organiser and/or their personnel, staff
                          and security personnel, threats, or statements
                          offensive to TCCC, its direct or indirect
                          subsidiaries, its Brands or anything that might be
                          construed as offensive towards the same, both in India
                          and USA. It is further clarified that the Organiser
                          shall not be liable to indemnify the Participant or
                          Winner in any form with respect to the same.
                        </li>
                      </ol>
                    </ol>
                    <ul>
                      <li>Additional General Terms and Conditions</li>
                      <ul>
                        <li>
                          This Promotion is not available to employees, of the
                          Organiser, its clients or agencies and their immediate
                          families.
                        </li>
                        <li>
                          Any costs associated with entering the Promotion,
                          including accessing the Promotion Website, are the
                          responsibility of each Participant. Also, regular call
                          and message rates will apply as per the consumer
                          telecom operator in their respective circles.
                        </li>
                        <li>
                          The Agency is acting as an executing agency for this
                          Promotion and holds no legal and financial liability
                          on unclaimed Prize (s), incentives, etc. beyond the
                          applicable period of the Promotion.
                        </li>
                        <li>
                          This Promotion is subject to promotional availability
                          and government regulations.
                        </li>
                        <li>
                          The Organiser reserves the right to change the terms
                          and conditions of this scheme, including extending,
                          withdrawing, or discontinuing the same without notice,
                          without assigning any reason, at their sole discretion
                          and without any liability.
                        </li>
                        <li>
                          If this promotion is interfered with in any way or is
                          not capable of being conducted as reasonably
                          anticipated due to any reason beyond the reasonable
                          control of the Organiser, including but not limited to
                          technical difficulties, unauthorized intervention or
                          fraud, the Organiser reserves the right, in its sole
                          discretion, to the fullest extent permitted by law (a)
                          to invalidate any customer; or (b) subject to any
                          written directions from a regulatory authority, to
                          modify, suspend, terminate or cancel the promotion, as
                          appropriate.
                        </li>
                        <li>
                          is the Organiser are not responsible for any problems
                          or technical malfunction of any telephone or network
                          or lines, servers or providers, computer equipment,
                          software, technical problems or traffic congestion on
                          a mobile network, or any combination thereof, or any
                          other technical failures including any damage to
                          Participant's or any other person's mobile handset or
                          computer related to, or resulting from, participation
                          in this Promotion or the downloading of any materials
                          related to this Promotion
                        </li>
                        <li>
                          If for any reason this Promotion is not capable of
                          running as planned because of infection by computer
                          virus, bugs, tampering, unauthorized intervention,
                          technical failures or any other causes beyond the
                          reasonable control of the Agency which corrupt or
                          affect the administration, security, fairness,
                          integrity or proper conduct of this Promotion, the
                          Agency or CCIPL reserves the right in its sole
                          discretion to cancel, terminate, modify or suspend the
                          Promotion, subject to any written directions made
                          under applicable State or Territory legislation.
                        </li>
                        <li>
                          Caution: Any attempt to deliberately damage the
                          Agency’s Promotion Website or the information on the
                          Promotion Website, to cause malicious damage or
                          interference with the normal functioning of the
                          Promotion Website, or to otherwise undermine the
                          legitimate operation of this Promotion may be a
                          violation of criminal and civil laws and should such
                          an attempt be made, whether successful or not, the
                          Agency reserves the right to seek damages to the
                          fullest extent permitted by law. If the Agency suffers
                          loss or incurs any costs in connection with any breach
                          of these Terms or any other legal obligation by a
                          Participant, the Participant agrees to indemnify the
                          Agency for those losses, damages, and costs.
                        </li>
                        <li>
                          The Agency/Logistic Partner, its clients, agents, and
                          distributors accept no responsibility, financial or
                          otherwise for the misuse of the Prize(s)and are not
                          liable for any personal loss or injury and cannot be
                          held responsible for any disagreement concerning
                          quality/ availability of the Prize(s).
                        </li>
                      </ul>
                    </ul>
                    <ul>
                      <ul>
                        <li>
                          The Agency/the Logistic Partner, its clients, agents,
                          and distributors cannot replace any lost, stolen or
                          damaged Prize(s) and reserve the right to withdraw or
                          amend any details and/or prices without notice.
                        </li>
                      </ul>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>13</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Release and Limitations of Liability</strong>
                      <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <ol type="i" start={1}>
                      <li>
                        By entering the Promotion, the Participants hereby
                        release from and agree to indemnify CCIPL, and/ or any
                        of their respective officers/employees from and against
                        all liability, cost, loss or expense arising out of
                        acceptance of the Prize or participation in the
                        Promotion including (but not limited to) personal injury
                        and damage to property and whether direct, indirect,
                        consequential, foreseeable, due to some negligent act or
                        omission, or otherwise.
                      </li>
                      <li>
                        CCIPL accept no liability, whether jointly or severally,
                        for any errors or omissions, whether on behalf of
                        themselves or third parties in relation to the Prizes.
                        CCIPL, and any of their respective parent companies,
                        subsidiaries, affiliates, directors, officers,
                        professional advisors, employees and agencies will not
                        be responsible for any late, lost, misrouted, or
                        distorted or damaged transmissions or entries.
                      </li>
                      <li>
                        The Participant(s) shall be solely responsible for any
                        consequences which may arise due to their participation
                        in the Promotion by conducting an illegal act.
                        Participant(s) also undertakes to indemnify CCIPL and
                        their respective officers, directors, employees and
                        agents on the happening of such an event (including
                        without limitation cost of attorney, legal charges etc.)
                        on full indemnity basis for any loss/damage suffered by
                        CCIPL on account of such act on the part of the
                        Participant. Participant(s) hereby agree to indemnify,
                        defend and hold harmless CCIPL in case of any loss or
                        liability (including but not limited to liabilities,
                        judgments, damages, losses, fines and penalties, claims,
                        costs and expenses such as attorneys’ fees and expenses)
                        or any other loss associated with, arising out of or
                        incidental to their ineligibility to participate, any
                        untoward, rash or negligent act on their part, or
                        non-compliance or alleged non-compliance with these
                        Terms, any other rules, regulations, directives (whether
                        written or verbal) issued by CCIPL from time to time,
                        during the Promotion.
                      </li>
                      <li>
                        To the fullest extent permitted by law, in no event will
                        CCIPL or any of its officers, servants, employees,
                        representatives and/or agents (including without
                        limitation, any third party service providers that CCIPL
                        may engage for purposes of the Promotion), be liable for
                        any loss or damages (including, without limitation loss
                        of income, profits or goodwill, indirect, incidental,
                        consequential, exemplary, punitive or special damages of
                        any party including third parties) howsoever arising
                        whether in contract, tort, negligence or otherwise, in
                        connection with the Promotion and/or the Promotion
                        Prizes, even if CCIPL has been advised of the
                        possibility of such damages in advance, and all such
                        damages are expressly excluded. The Participant shall
                        indemnify, defend, and hold CCIPL harmless in the event
                        of there being any third party/entity/organization
                        claims arising from or related to his/her participation
                        in the Promotion. In no event shall CCIPL and be liable
                        to any Participant for acts or omissions arising out of
                        or related to the Promotion or his/her participation in
                        the Promotion.
                      </li>
                      <li>
                        In consideration of CCIPL allowing the Participant(s) to
                        take part in the Promotion, to the maximum extent
                        permitted by law, the Participant(s) waive and release
                        each and every right or claim, all actions, causes of
                        actions (present or future) each of them has or may have
                        against CCIPL, its respective agents, directors,
                        officers, business associates, group companies,
                        sponsors, employees, or representatives for all and any
                        injuries, accidents, or mishaps (whether known or
                        unknown) or (whether anticipated or unanticipated)
                        arising out of the Promotion or related to the Promotion
                        or the Prizes of the Promotion.
                      </li>
                    </ol>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>14</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Dispute</strong> <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <ol type="i" start={1}>
                      <li>
                        The courts of competent jurisdiction at Gurgaon shall
                        have exclusive jurisdiction to determine any and all
                        disputes arising out of, or in connection with, the
                        Promotion.
                      </li>
                      <li>
                        Participation in the Promotion is unauthorized in any
                        jurisdiction that does not give effect to all provisions
                        of these Terms, including without limitation, this
                        clause.
                      </li>
                      <li>
                        Further all issues and questions concerning the
                        construction, validity, interpretation and
                        enforceability of these Terms, or the rights and
                        obligations of the Participants and/or CCIPL and/or
                        partners of this Promotion, shall be governed and
                        construed in accordance with the laws of the Republic of
                        India.
                      </li>
                    </ol>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FIFATerms;
